module.exports = __webpack_public_path__ + "ce905659870f86e3a9def05579382d2c.png";